import {
    EarlyBirdOfferDto,
    EarlyBirdConditionDto,
    EarlyBirdRuleDto,
} from "app/shared/model/EarlyBirdOfferDto";
import { Country } from "app/shared/model/Country";
import { School } from "app/shared/model/School";
import { BookingSystem } from "app/shared/model/BookingSystem";
import { CourseProduct } from "app/shared/model/Course";
import { AccommodationProduct } from "app/shared/model/Accommodation";
import { AddOnsProduct } from "app/shared/model/AddOns";
import { Agent } from "app/shared/model/Agent";
import { AddonType } from "app/shared/model/AddonType";
import { AccommodationTypeValue } from "app/shared/model/AccommodationTypeValue";
import { Product } from "app/shared/model/ProductBase";
import { TransfersProduct } from "app/shared/model/Transfers";

export type EarlyBirdConditionWithUiId = EarlyBirdConditionDto & { uiId: string };

export interface EarlyBirdRuleWithUiId {
    name: string;
    earlyBirdEndDate: string;
    include: EarlyBirdConditionWithUiId[];
    exclude: EarlyBirdConditionWithUiId[];
}

export interface BuilderPageLoadedData {
    countries: Country[];
    schools: School[];
    bookingSystems: BookingSystem[];
    courses: CourseProduct[];
    accommodations: AccommodationProduct[];
    addOns: AddOnsProduct[];
    accommodationRooms: Product[];
    addOnTypes: AddonType[];
    accommodationTypes: AccommodationTypeValue[];
    admissionRegions: string[];
    agents: Agent[];
    transfers: TransfersProduct[];
}

export enum ActionType {
    PageLoaded = "EarlyBirdOfferBuilder/PageLoaded",
    SetRules = "EarlyBirdOfferBuilder/SetRules",
    AddRule = "EarlyBirdOfferBuilder/AddRule",
    RemoveRule = "EarlyBirdOfferBuilder/RemoveRule",
    UpdateRule = "EarlyBirdOfferBuilder/UpdateRule",
    AddCondition = "EarlyBirdOfferBuilder/AddCondition",
    RemoveCondition = "EarlyBirdOfferBuilder/RemoveCondition",
    UpdateCondition = "EarlyBirdOfferBuilder/UpdateCondition",
    SetEditingConditionUiId = "EarlyBirdOfferBuilder/SetEditingConditionUiId",
    Other = "__OTHER__",
}

export type PageLoadedEvent = {
    type: ActionType.PageLoaded;
    rules: EarlyBirdRuleWithUiId[];
    year: number;
    divisionId: number;
    data: BuilderPageLoadedData;
};

export type SetRulesEvent = {
    type: ActionType.SetRules;
    rules: EarlyBirdRuleWithUiId[];
};

export type AddRuleEvent = {
    type: ActionType.AddRule;
};

export type RemoveRuleEvent = {
    type: ActionType.RemoveRule;
    ruleIndex: number;
};

export type UpdateRuleEvent = {
    type: ActionType.UpdateRule;
    ruleIndex: number;
    patch: Partial<Pick<EarlyBirdRuleDto, "name" | "earlyBirdEndDate">>;
};

export type AddConditionEvent = {
    type: ActionType.AddCondition;
    ruleIndex: number;
    lane: "include" | "exclude";
    condition: EarlyBirdConditionWithUiId;
};

export type RemoveConditionEvent = {
    type: ActionType.RemoveCondition;
    ruleIndex: number;
    lane: "include" | "exclude";
    uiId: string;
};

export type UpdateConditionEvent = {
    type: ActionType.UpdateCondition;
    ruleIndex: number;
    lane: "include" | "exclude";
    uiId: string;
    condition: EarlyBirdConditionWithUiId;
};

export type SetEditingConditionUiIdEvent = {
    type: ActionType.SetEditingConditionUiId;
    uiId: string | null;
};

export type OtherAction = { type: ActionType.Other };

export type Action =
    | PageLoadedEvent
    | SetRulesEvent
    | AddRuleEvent
    | RemoveRuleEvent
    | UpdateRuleEvent
    | AddConditionEvent
    | RemoveConditionEvent
    | UpdateConditionEvent
    | SetEditingConditionUiIdEvent
    | OtherAction;